// helpers/ImageHelper.js - Fixed version
export function getImageURL(path) {
  if (!path) return null;
  
  // If it's an absolute URL (like Google Drive or another site), return it directly
  if (path.startsWith('http://') || path.startsWith('https://')) {
    // Check if it's a Google Drive link and convert it to a fast thumbnail link
    if (path.includes('drive.google.com/file/d/')) {
      const match = path.match(/\/d\/([a-zA-Z0-9_-]+)/);
      if (match && match[1]) {
        // Use /thumbnail endpoint — much faster than /uc which does virus scans
        // and shows "confirm download" pages that block image loading.
        // sz=w600 requests a 600px wide image (good for menu cards).
        return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w600`;
      }
    }
    // Google Drive /uc links that were already saved in the database
    if (path.includes('drive.google.com/uc?id=')) {
      const match = path.match(/[?&]id=([a-zA-Z0-9_-]+)/);
      if (match && match[1]) {
        return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w600`;
      }
    }
    return path;
  }
  
  const baseURL = import.meta.env.VITE_BACKEND_IMAGES_BASE_URL;
  if (!baseURL) return null;
  
  // Remove /public/ from path if it exists (since baseURL already includes it)
  let cleanPath = path.replace(/^\/?public\//, '');
  
  // Remove any remaining leading slashes
  cleanPath = cleanPath.replace(/^\//, '');
  
  return `${baseURL}/${cleanPath}`;
}